    <div
      colspan="5"
      class="
        py-0
        block
        text-center
        white-space-nowrap
        w-full
        text-sm
      "
    >
      <div class="my-5 w-full text-center text-lg">
        {{
          'ADMIN.SUBSCRIPTION.NO_SERVICE_ADDED' | translate
        }}
      </div>
      <button
        pButton
        pRipple
        type="button"
        label="{{
          'ADMIN.SUBSCRIPTION.ADD_SERVICE' | translate
        }}"
        icon="fa fa-plus"
        (click)="addServiceModal()"
        class="p-button-outlined text-sm surface-0"
      ></button>
      <br /><br /><br />
      <img
        width="300"
        src="/assets/img/no-services-added.jpg"
        alt="No service added!"
      />
      </div>

